import React from "react";

interface FlagIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const FlagIcon: React.FC<FlagIconProps> = ({
  width = 12,
  height = 15,
  color = "#1A1A1A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 15V0H1.5V1.5H12L10.5 5.25L12 9H1.5V15H0ZM5.625 6.75C6.0375 6.75 6.39063 6.60312 6.68438 6.30937C6.97813 6.01562 7.125 5.6625 7.125 5.25C7.125 4.8375 6.97813 4.48437 6.68438 4.19062C6.39063 3.89687 6.0375 3.75 5.625 3.75C5.2125 3.75 4.85938 3.89687 4.56563 4.19062C4.27188 4.48437 4.125 4.8375 4.125 5.25C4.125 5.6625 4.27188 6.01562 4.56563 6.30937C4.85938 6.60312 5.2125 6.75 5.625 6.75ZM1.5 7.5H9.7875L8.8875 5.25L9.7875 3H1.5V7.5Z"
        fill={color}
      />
    </svg>
  );
};

export default FlagIcon;
